var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.title,"size":_vm.size,"ok-title":_vm.okTitle,"cancel-title":_vm.cancel},on:{"ok":_vm.onConfirm,"cancel":_vm.onCancel}},[_vm._t("default",[_vm._v("Are you sure?")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }